export default __webpack_public_path__ + "static/unlimited-package-97c5f8ba1aee10a054b8f468ceffad0d.svg";